/**
 * Email-specific message header (subject, reply context, full datetime).
 */
import { fechaYHora } from '../lib/fechas';

export default function EmailMessageContext({ message, channel, isUserBubble }) {
  if ((channel || '').toLowerCase() !== 'email' || !message) return null;

  const meta = message.metadata && typeof message.metadata === 'object' ? message.metadata : {};
  const subject = meta.subject;
  const inReplySubject = meta.in_reply_to_subject;
  const inReplySnippet = meta.in_reply_to_snippet;

  if (!subject && !inReplySubject) return null;

  const textClass = isUserBubble ? 'text-white/80' : 'text-zinc-500';

  return (
    <div className={`mb-1.5 pb-1.5 border-b ${isUserBubble ? 'border-white/20' : 'border-zinc-200'}`}>
      {subject && (
        <p className={`text-[11px] font-medium ${isUserBubble ? 'text-white/90' : 'text-zinc-700'}`}>
          {subject}
        </p>
      )}
      {inReplySubject && (
        <p className={`text-[10px] mt-0.5 ${textClass}`}>
          En respuesta a: {inReplySubject}
          {inReplySnippet ? ` — "${inReplySnippet}"` : ''}
        </p>
      )}
    </div>
  );
}

export function formatDateTime(ts) {
  return fechaYHora(ts, '');
}
